export * from './cart-item-type-constants';
export * from './feature-constants';
export * from './cart-type-enum';

export const HEARING_AIDS_URL_PARAMS =
    'attributeDefinitions=Category:BTE Only,Category:RIC with Stock Receiver,Category:Custom Only&menuType=Hearing Aids';

export interface IValueText {
    text: string;
    value: string;
}
export interface ITextBoolean {
    text: string;
    value: boolean;
    english?: string;
}
export interface IAction {
    type: string;
}
export interface IOrderCenterItem {
    title: string;
    brand?: string;
    englishPdf?: string;
    localePdf?: string;
}
export interface IOrderCenterForm {
    productForms: IOrderCenterItem[];
    earmoldForms: IOrderCenterItem[];
    serviceRepairForms: IOrderCenterItem[];
}

export interface IStarkeyContact {
    title: string;
    name?: string;
    telephone: string;
    email: string[];
}
